<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('common:province_plural') }}
        </h2>

        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            :addBtnText="$t('buttons:add-specific', {specific: $t('common:province') })"
            icon="edit"
            @updateTableData="updateTable"
            @clickedButton1="editProvince"
            @clickedAddButton="editProvince"
            :addBtn="true"
            sortBy="name"
        />

      </v-col>
    </v-row>

    <ProvinceForm
        @updateTable="updateTableAfterManipulation"
        ref="provinceForm"
        :countries="countries" />

  </div>
</template>
<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import ProvinceForm from '@/modules/settings/views/settings/province/ProvinceForm';
import ProvinceService from '@/modules/settings/services/province-service';
import InfoService from '@/modules/core/services/info-service';
import Province from '@/modules/settings/data/province';
import Country from "@/modules/settings/data/country";
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';

export default {
  name: "ProvinceTable",
  components: {
    ProvinceForm,
    DataTablePaginated
  },
  data() {
    return {
      country: new Country(),
      provinces: [],
      countries: [],
      translatedCountries: new Map()
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:id'), value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:country'), value: 'countryTranslatedName'},
        {text: "", value: "controls", sortable: false}
      ]
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      ProvinceService.readAllProvincePaginated(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (response) => {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Province);
            response.data.content.forEach(
                (province) => {
                  province.countryTranslatedName = this.translatedCountries.get(province.country);
                }
            )
            this.$refs.table.fillTableData(response.data);
          },
          () => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:province.province')}));
          }
      )
    },
    updateTableAfterManipulation() {
      this.$refs.table.callTableUpdate();
    },
    editProvince(province) {
      this.$refs.provinceForm.initialization(province);
    }
  },
  created() {
    InfoService.readOptionsByUrl(
        'country',
        (response) => {
          this.countries = Utils.translateAllCountries(response);
          for (let i = 0; i < this.countries.length; i++) {
            this.translatedCountries.set(this.countries[i]['id'], this.countries[i]['translatedName']);
          }
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:country.title')}));
        }
    )
  }
}
</script>